import { render, staticRenderFns } from "./ghImage.vue?vue&type=template&id=bca0473c&scoped=true&"
import script from "./ghImage.vue?vue&type=script&lang=js&"
export * from "./ghImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca0473c",
  null
  
)

export default component.exports